module.exports = __webpack_public_path__ + "packs/media/images/Meet-91ed8d683fac24ab2b90f54e528309cd.svg";